
// Header.js

import React from 'react'
import { NavLink } from "react-router-dom";

import '../../styles/navigation/Layout.css';
import NicheWareLogo from '../../images/logo/logo512.png';
import Button from '../buttons/Button';
import Logo from '../design/Logo';

import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '../../hooks/useMediaQuery';

// Only matters while the desktop header is mounted, so it lives here rather
// than in DeviceContext — nothing else in the tree needs to know about it.
const DESKTOP_FULL_BREAKPOINT = 1200; // >= : full logo, < : icon-only logo

const HeaderDesktop = () => {

    const navigate = useNavigate();

    // Simplify the logo (icon + name + subtext -> icon only) as the desktop
    // window narrows below the breakpoint.
    const isFullLogo = useMediaQuery(`(min-width: ${DESKTOP_FULL_BREAKPOINT}px)`);
    const desktopLogoVariant = isFullLogo ? 'full' : 'icon';


    const handleContactClick = () => {
        navigate('/contact');
    }

    return (<>
        {/* The flex box the Header Banner */}
        <div className="header-bar-box">
            <div className="header-bar-content">

                {/* Brand section */}
                <div className="header-bar-inner-box">
                    <Logo variant={desktopLogoVariant} size="small" mode="light" />

                </div>

                {/* Nav links — centered (desktop only) */}
                <div className='header-bar-subtitle-list'>
                    <NavLink to={`/home`} exact className="header-bar-subtitle-button">
                        {"Home"}
                    </NavLink>
                    <NavLink to={`/products`} exact className="header-bar-subtitle-button">
                        {"Products"}
                    </NavLink>
                    {/* <NavLink to={`/process`} exact className="header-bar-subtitle-button">
                        {"Process"}
                    </NavLink> */}
                    <NavLink to={`/team`} exact className="header-bar-subtitle-button">
                        {"Team"}
                    </NavLink>
                </div>

                <div className='header-bar-contact-button-container'>
                    <Button onClick={handleContactClick}  disabled={false}>
                        Contact Us
                    </Button>
                </div>
                


            </div>

        </div>
    </>)
}

export default HeaderDesktop
